const ReasoningLevel = {
	LEXICAL: 'Lexikális tudás, memorizálás',
	ANALYTIC: 'Összegző, összehasonlító tudás',
};

export default ReasoningLevel;